import { createReducer, on } from "@ngrx/store";
import { inviteUserCreateState } from "../invite-user.state";
import * as inviteUserAction from '../actions/invite-user.action';

const initialState: inviteUserCreateState = {
    companyList: null,
    formData: null,
    tableData: null,
    loading: false,
    success: null,
    error: null
}

export const InviteUserReducer = createReducer(
    initialState,
    on(
        inviteUserAction.getCompanyNameList,
        (state: inviteUserCreateState) => ({
            ...state,
            loading: true,
            success: null,
            error: null,
        })
    ),
    on(
        inviteUserAction.getCompanyNameListSuccess,
        (state: inviteUserCreateState, { companyList }) => ({
            ...state,
            companyList,
            loading: null,
            success: true,
            error: null,
        })
    ),
    on(
        inviteUserAction.getCompanyNameListFail,
        (state, { payload }) => ({
            ...state,
            loading: null,
            success: null,
            error: payload
        })),
    on(
        inviteUserAction.setFormValues,
        (state: inviteUserCreateState, { formData }) => ({
            ...state,
            formData,
        })),
    on(
        inviteUserAction.tableConfigurationLoaded,
        (state: inviteUserCreateState, { tableData }) => ({
            ...state,
            tableData,
        })),
    on(
        inviteUserAction.clearTable,
        (state: inviteUserCreateState) => ({
            ...state,
            tableData: {
                ...state.tableData,
                salesTableData: [],
                notSalesTableData: [],
            }
        })
    ),
    on(inviteUserAction.checkNotSaleTableData,
        (state: inviteUserCreateState, { notSaleRowUpdates }) => {
            const updatedNotSalesTableData = state.tableData.notSalesTableData.map(
                (item) => {
                    if (item.legalEntity === notSaleRowUpdates.legalEntity) {
                        return {
                            ...item,
                            Requester: notSaleRowUpdates.Requester,
                            Purchaser: notSaleRowUpdates.Purchaser,
                            CustomerAdmin: notSaleRowUpdates.CustomerAdmin,
                        };
                    }
                    return item;
                }
            );
            return {
                ...state,
                tableData: {
                    ...state.tableData,
                    notSalesTableData: updatedNotSalesTableData,
                },
            };
        }
    ),
    on(inviteUserAction.removeSalesTableData,
        (state: inviteUserCreateState, { rowForRemove }) => {
            const updatedSalesTableData = state.tableData.salesTableData.filter(
                (item) => item.legalEntity !== rowForRemove.legalEntity
            );
            return {
                ...state,
                tableData: {
                    ...state.tableData,
                    salesTableData: updatedSalesTableData,
                },
            };
        }
    ),
    on(
        inviteUserAction.clearInviteUserState,
        (state: inviteUserCreateState) => ({
            ...initialState
        })
    )
)